export default __webpack_public_path__ + "static/media/logo.055e8050.png";